import { Box, Divider, Typography } from '@mui/material';
import { PatientMatchActivity, UserProfile } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';
import { formatReferrerNameWithCredentials } from '@uplift/utils';
import { usePartnerReferralDetailsStyles } from '../styles';
import { ReferralDetailsSection } from './ReferralDetails.component';
import { NoteDetails } from './NoteDetails.component';
import { ReviewLayoutContent } from '../../../../../../Layout';
import { User } from '@uplift/types';

export type PsychiatryReferralDetailsProps = {
  activityItem: PatientMatchActivity;
};

export const PsychiatryReferralDetails: React.VFC<PsychiatryReferralDetailsProps> = ({ activityItem }) => {
  const { classes } = usePartnerReferralDetailsStyles();
  const referralDate = CalendarDateService.date(activityItem.datetime).tz(CalendarDateService.timezones.ET);
  const referrerNameWithCredentials = formatReferrerNameWithCredentials(activityItem?.fromUser?.user as User, activityItem?.fromUser?.profile as UserProfile);

  return (
    <ReviewLayoutContent title="Psychiatry Referral" subtitle={`by ${activityItem?.fromUser?.user?.firstName[0]}. ${activityItem?.fromUser?.user?.lastName}`}>
      <Box className={classes.content}>
        <Box display="flex" flexDirection="column">
          <Typography variant="overline" className={classes.subTitle}>
            Referring Provider
          </Typography>
          <Typography variant="body1" data-testid="referral-from">
            {referrerNameWithCredentials}
          </Typography>
          <Typography variant="body1" data-testid="referral-contact">
            <span className={classes.weightBold}>Contact: </span>
            {activityItem.fromUser?.user?.email}
          </Typography>
        </Box>
        <Divider />
        <Box display="flex" flexDirection="column" gap="8px">
          <Typography variant="overline" className={classes.subTitle}>
            Referral Note
          </Typography>
          <NoteDetails content={activityItem.match.psychReferralNote ?? 'No Note'} />
        </Box>
        <Divider />
        <Box display="flex" flexDirection="column" gap="8px">
          <ReferralDetailsSection
            referralDate={referralDate}
          />
        </Box>
      </Box>
    </ReviewLayoutContent>
  );
};
